import StaticPage, { Section } from "../components/StaticPage";
import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";

const UPCOMING = [
    {
        title: "Vendor Night · Live Resin Lab",
        when: "Saturday · 4 PM – 9 PM",
        where: "ZenZest Queens · 272-06 Union Tpke",
        body: "An evening with our live-resin makers. Side-by-side single-source tastings, hash-rosin history, plus a 10% off member discount on every featured SKU. Free to attend, 21+ ID at the door.",
    },
    {
        title: "Strain Drop · Acapulco Gold",
        when: "Friday · 12 PM – 8 PM",
        where: "Both stores · Queens & Staten Island",
        body: "Heavy Hitters' archival Acapulco Gold returns for one weekend only. First 100 customers per store get a complimentary strain card and a limited cone holder.",
    },
    {
        title: "Hash Hangs · Live Rosin 101",
        when: "Sunday · 2 PM – 5 PM",
        where: "ZenZest Staten Island · 2343 Forest Ave",
        body: "An informal afternoon with two of NY's most decorated rosin pressers. We'll cover wash math, freezer prep, and what 'cold cure' actually means. RSVP not required.",
    },
    {
        title: "Wellness Tuesday · Topicals & Tinctures",
        when: "Tuesday · 12 PM – 6 PM",
        where: "ZenZest Queens · 272-06 Union Tpke",
        body: "Calmer than a vendor night. Brand educators on hand to walk through our full topicals and tincture line, plus an entry-level dosing guide for new and returning users.",
    },
];

const PAST = [
    "Holiday Edition · Vendor Bazaar — 14 brands, 4 hours, hot cider and a hash-pressing demo",
    "Cannabis 101 · A guided walk through our menu for first-time customers",
    "Local Roots · Spotlight on NY craft growers and their sungrown harvests",
    "Member Preview · 24-hour early-access to spring concentrates lineup",
];

export default function Events() {
    return (
        <StaticPage
            title="Events & Vendor Pop-Ups — ZenZest"
            description="Tastings, vendor nights, strain drops, and education events at ZenZest Queens and Staten Island. Free to attend, 21+ ID required."
            canonical="https://weeddispensarynearme.com/events"
            eyebrow="Events"
            h1="Tastings, drops, and the people behind the plant."
            intro="Vendor pop-ups, member previews, and a calmer learning series at both ZenZest flagships. Free to attend, no purchase required, 21+ ID at the door."
            cta={[
                { label: "RSVP via SMS", href: "/queens/contact", primary: true },
                { label: "Visit a store", href: "/locations" },
            ]}
        >
            <Section id="upcoming" title="Upcoming">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 not-prose mt-2">
                    {UPCOMING.map((e) => (
                        <div
                            key={e.title}
                            data-testid={`event-${e.title.replace(/\s+/g, "-").toLowerCase()}`}
                            className="p-5 bg-zen-surface border border-zen-line"
                        >
                            <h3 className="font-serif text-xl text-zen-ink font-light leading-tight mb-3">
                                {e.title}
                            </h3>
                            <p className="text-[11px] uppercase tracking-[0.22em] text-zen-olive flex items-center gap-1.5 mb-1.5">
                                <Calendar size={11} /> {e.when}
                            </p>
                            <p className="text-[11px] uppercase tracking-[0.22em] text-zen-ink-soft flex items-center gap-1.5 mb-3">
                                <MapPin size={11} /> {e.where}
                            </p>
                            <p className="text-sm text-zen-ink-soft leading-relaxed">
                                {e.body}
                            </p>
                        </div>
                    ))}
                </div>
            </Section>

            <Section id="recent" title="Recently at ZenZest">
                <ul className="space-y-2 text-sm">
                    {PAST.map((p) => (
                        <li key={p} className="flex gap-2 text-zen-ink-soft">
                            <span className="text-zen-olive">·</span>
                            <span>{p}</span>
                        </li>
                    ))}
                </ul>
            </Section>

            <Section id="rsvp" title="How RSVP works">
                <p>
                    Most events are walk-in. For seated tastings and limited-capacity
                    sessions we run a text-based RSVP via Alpine IQ — share your number
                    on the{" "}
                    <Link to="/queens/contact" className="text-zen-ink underline">
                        contact page
                    </Link>{" "}
                    and we&rsquo;ll send a single confirmation with date, time, and any
                    pre-event notes.
                </p>
                <p className="not-prose">
                    <Link
                        to="/queens/contact"
                        className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-zen-olive border-b border-zen-olive/40 pb-0.5"
                    >
                        RSVP for the next event <ArrowRight size={11} />
                    </Link>
                </p>
            </Section>
        </StaticPage>
    );
}
